import { inject } from 'mobx-react';
import { HeaderComponent } from './component';
export const Header = inject(({ ui, auth }) => ({
    user: auth.userData,
    logout: auth.logout,
    menu: ui.menu,
}))(HeaderComponent);
//# sourceMappingURL=index.js.map